import { EhrProviderParticipant } from "../../entities/ehr-provider.model";

export class PtEhrMrnInfoForm {
	data: PtEhrMrnInfo[];

	constructor(params: EhrProviderParticipant[]) {
		this.data = params.map((x) => new PtEhrMrnInfo(x));
	}
}

export class PtEhrMrnInfo {
	id: number | null;
	participantId: number;
	ehrProviderId: number | null;
	providerParticipantId: string | null;
	createdOn: string | null;
	updatedOn: string | null;

	constructor(params: Partial<EhrProviderParticipant>) {
		this.id = params.id ?? null;
		this.participantId = params.participantId!;
		this.ehrProviderId = params.ehrProviderId ?? null;
		this.providerParticipantId = params.providerParticipantId ?? null;
		this.createdOn = params.createdOn ?? null;
		this.updatedOn = params.updatedOn ?? null;
	}
}
